<script setup>
import { computed } from 'vue'
import { useForm, usePage } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import HostAuthLayout from '@/Layouts/HostAuthLayout.vue'

defineOptions({ layout: HostAuthLayout })

const { t } = useI18n()
const page = usePage()
const flash = computed(() => page.props.flash || {})
const form = useForm({ password: '', password_confirmation: '' })

function submit() {
  form.transform((d) => ({ portal_account: d }))
      .patch('/password', { preserveScroll: true })
}
</script>

<template>
  <h1 class="edit-title">
    {{ t('host_portal.password_edit.title') }}
  </h1>
  <div
    v-if="flash.alert"
    class="edit-alert"
    role="alert"
  >
    {{ flash.alert }}
  </div>
  <form
    class="edit-form"
    @submit.prevent="submit"
  >
    <label class="edit-field">
      <span class="edit-label">{{ t('host_portal.password_edit.new') }}</span>
      <input
        v-model="form.password"
        type="password"
        autocomplete="new-password"
        minlength="6"
        required
        class="edit-input"
      >
    </label>
    <label class="edit-field">
      <span class="edit-label">{{ t('host_portal.password_edit.confirm') }}</span>
      <input
        v-model="form.password_confirmation"
        type="password"
        autocomplete="new-password"
        minlength="6"
        required
        class="edit-input"
      >
    </label>
    <button
      type="submit"
      :disabled="form.processing"
      class="edit-submit"
    >
      {{ form.processing ? t('host_portal.profile.change.cta.loading') : t('host_portal.password_edit.cta') }}
    </button>
  </form>
</template>

<style scoped>
.edit-title { font-size: 1.25rem; font-weight: 700; color: var(--ink); margin: 0 0 0.5rem; }
.edit-alert {
  padding: 0.6rem 0.8rem; margin-bottom: 0.75rem;
  background: color-mix(in oklch, var(--danger) 12%, var(--surface));
  color: var(--danger); border-radius: 0.5rem; font-size: 0.875rem;
}
.edit-form  { display: grid; gap: 0.875rem; }
.edit-field { display: grid; gap: 0.3rem; }
.edit-label { font-size: 0.8125rem; color: var(--inkSoft); }
.edit-input {
  width: 100%; padding: 0.55rem 0.75rem; background: var(--surface);
  border: 1px solid var(--line); border-radius: var(--radius-input, 8px);
  color: var(--ink); font-size: 0.9375rem;
}
.edit-input:focus { outline: 2px solid var(--accent); outline-offset: 1px; }
.edit-submit {
  padding: 0.65rem 1rem; border: 0; border-radius: var(--radius-button, 8px);
  background: var(--accent); color: var(--accentInk); font-weight: 600; cursor: pointer;
}
.edit-submit:disabled { opacity: 0.6; }
</style>
